const TRANSLATION_NAMESPACE = "error:agents."

export const GET_AGENTS_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}get-agents-failed`
export const GET_AGENT_DECLARATIONS_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}get-agent-declarations-failed`
export const CREATE_AGENT_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}create-agent-failed`
export const UPDATE_AGENT_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}update-agent-failed`
export const DELETE_AGENT_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}delete-agent-failed`
